import { z } from "zod";
import type {
    PayRequestPaymentCancelledEvent} from "./pay-request.payment-cancelled.event";
import {
    payRequestPaymentCancelledEventZodObject,
} from "./pay-request.payment-cancelled.event";
import type {
    PayRequestPaymentExpiredEvent} from "./pay-request.payment-expired.event";
import {
    payRequestPaymentExpiredEventZodObject,
} from "./pay-request.payment-expired.event";
import type {
    PayRequestPaymentFailedEvent} from "./pay-request.payment-failed.event";
import {
    payRequestPaymentFailedEventZodObject,
} from "./pay-request.payment-failed.event";
import type {
    PayRequestPaymentFulfilledEvent} from "./pay-request.payment-fulfilled.event";
import {
    payRequestPaymentFulfilledEventZodObject,
} from "./pay-request.payment-fulfilled.event";
import type {
    PayRequestPaymentInitiatedEvent} from "./pay-request.payment-initiated.event";
import {
    payRequestPaymentInitiatedEventZodObject,
} from "./pay-request.payment-initiated.event";

type PayRequestPaymentEvent =
    | PayRequestPaymentCancelledEvent
    | PayRequestPaymentExpiredEvent
    | PayRequestPaymentInitiatedEvent
    | PayRequestPaymentFulfilledEvent
    | PayRequestPaymentFailedEvent;

const payRequestPaymentEventZodObjects = [
    payRequestPaymentCancelledEventZodObject,
    payRequestPaymentExpiredEventZodObject,
    payRequestPaymentInitiatedEventZodObject,
    payRequestPaymentFulfilledEventZodObject,
    payRequestPaymentFailedEventZodObject,
] as const;

const payRequestPaymentEventZodDiscriminatedUnion = z.union([
    ...payRequestPaymentEventZodObjects,
]);
const payRequestPaymentEventZodSchema: z.ZodSchema<PayRequestPaymentEvent> =
    payRequestPaymentEventZodDiscriminatedUnion;

export {
    payRequestPaymentEventZodDiscriminatedUnion,
    payRequestPaymentEventZodObjects,
    payRequestPaymentEventZodSchema,
};
export type { PayRequestPaymentEvent };
